import React from "react";
import { css } from "emotion";
import PropTypes, { bool } from "prop-types";
import { CSSTransition } from "react-transition-group";
import Button from "../../button/button";

import { defaultStyle, contentStyle, titleStyle, descriptionStyle, buttonStyle } from "./style";

const Modal = props => {
	const isDescriptionObject = typeof props.description === "object";
	const isTitleObject = typeof props.title === "object";

	return (
		<CSSTransition in={props.show} unmountOnExit timeout={1000}>
			<div
				className={css`
					${defaultStyle}
				`}
				id={props.idBackGround ? props.idBackGround : "backGroundModal"}
				style={{ position: props.fixed ? "fixed" : "absolute" }}
			>
				<div
					className={css`
						${contentStyle}
					`}
					id={props.id ? props.id : "modalDefaultId"}
					style={{
						width: `${isNaN(props.width) ? props.width : props.width + "px"}`,
						height: `${isNaN(props.height) ? props.height : props.height + "px"}`,
						borderRadius: `${isNaN(props.borderRadius) ? props.borderRadius : props.borderRadius + "px"
							}`,
						marginTop: `${isNaN(props.marginTop) ? props.marginTop : props.marginTop + "px"}`
					}}
				>
					{isTitleObject ? (
						<div
							className={css`
							${titleStyle}
						`}
						>
							{props.title}
						</div>
					) : (
						<div
							className={css`
								${titleStyle}
							`}
							dangerouslySetInnerHTML={{ __html: props.title }}
						/>
					)}

					{isDescriptionObject ? (
						<div
							className={css`
								${descriptionStyle}
							`}
						>
							{props.description}
						</div>
					) : (
						<div
							className={css`
								${descriptionStyle}
							`}
							dangerouslySetInnerHTML={{ __html: props.description }}
						/>
					)}
					{!props.dontUseDefaultOption && (
						<div
							className={css`
								${buttonStyle}
							`}
							style={{ justifyContent: !!props.cancel && "space-between" }}
						>
							{!!props.cancel && (
								<Button
									className="btn-gray-md-o"
									onClick={props.onCancel}
									{...(props.dataActionCancel ? { "data-action": props.dataActionCancel } : {})}
								>
									{props.cancel}
								</Button>
							)}
							<Button
								className="btn-primary-md"
								onClick={props.onConfirm}
								{...(props.dataActionConfirm ? { "data-action": props.dataActionConfirm } : {})}
							>
								{props.confirm}
							</Button>
						</div>
					)}
				</div>
			</div>
		</CSSTransition>
	);
};

Modal.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	title: PropTypes.any,
	description: PropTypes.any,
	dontUseDefaultOption: PropTypes.bool,
	confirm: PropTypes.string.isRequired,
	onConfirm: PropTypes.func.isRequired,
	cancel: PropTypes.string,
	onCancel: PropTypes.func,
	show: PropTypes.bool,
	centralArea: PropTypes.bool,
	id: PropTypes.string,
	idBackGround: PropTypes.string
};

Modal.defaultProps = {
	width: 490,
	height: 290,
	show: false,
	borderRadius: 16,
	marginTop: 45
};

export default Modal;
